import { useMemo } from 'react'
import { useUserVotes } from './useUserVotes'
import { BoxDto } from '../types/generated'

export const useBoxChoices = (params: { box: BoxDto }) => {
  // TODO: limit: 100 костыль, можно сделать ендпоинт который возвращает голосовал пользователь или нет
  const { data: userVotesData } = useUserVotes({ limit: 100 })

  // Merge user-specific vote data with box choices
  // BoxChoiceDto type includes `user_vote_summary` field, but it's only populated
  // for authenticated users in the response. We fetch user votes separately and
  // merge them with the box choices to ensure each choice has the correct
  // user_vote_summary (or null if the user hasn't voted on that choice)
  const boxChoices = useMemo(() => {
    // Flatten all pages to find user votes for this box
    const allUserVotes = userVotesData?.pages.flatMap(page => page.data) ?? []
    const userVotesForThisBox = allUserVotes.find(b => b.id === params.box.id)

    return [...params.box.boxChoices]
      .sort((a, b) => a.choiceIndex - b.choiceIndex)
      .map(choice => {
        const userChoice = userVotesForThisBox?.boxChoices.find(
          (uc: { choiceIndex: number }) =>
            uc.choiceIndex === choice.choiceIndex,
        )

        return {
          ...choice,
          user_vote_summary: userChoice?.user_vote_summary || null,
        }
      })
  }, [params.box, userVotesData])

  // Find the winning choice
  const winningChoice = useMemo(() => {
    if (params.box.winner === null) return null

    return boxChoices
      .filter(c => Boolean(c.user_vote_summary))
      .find(choice => choice.choiceIndex === params.box.winner)
  }, [params.box.winner, boxChoices])

  return {
    winningChoice,
    boxChoices,
  }
}
